import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const [mousePosition, setMousePosition] = useState({
    x: 50,
    y: 50
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = e.clientX / window.innerWidth * 100;
      const y = e.clientY / window.innerHeight * 100;
      setMousePosition({
        x,
        y
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);
  return <section className="relative min-h-screen w-full bg-black overflow-hidden flex items-center justify-center" data-id="element-28">
      {/* Spotlight effect following mouse */}
      <div className="absolute inset-0 pointer-events-none transition-all duration-300 ease-out" style={{
      background: `radial-gradient(ellipse 800px 600px at ${mousePosition.x}% ${mousePosition.y}%, rgba(255,255,255,0.06) 0%, transparent 70%)`
    }} data-id="element-29" />

      {/* Secondary fixed spotlight from top */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse 600px 800px at 50% -20%, rgba(255,255,255,0.1) 0%, transparent 60%)'
    }} data-id="element-30" />

      {/* Dancer silhouette image */}
      <div className="absolute inset-0 flex items-center justify-center opacity-30" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        scale: 1.1
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 2,
        ease: 'easeOut'
      }} className="w-full h-full" data-id="element-32">
          <img src="https://images.unsplash.com/photo-1508700929628-666bc8bd84ea?w=1920&q=80" alt="" className="w-full h-full object-cover motion-blur grayscale" style={{
          filter: 'contrast(2) brightness(0.4) grayscale(1)'
        }} data-id="element-33" />
        </motion.div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 60
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} data-id="element-35">
          <span className="text-white/60 text-sm tracking-[0.4em] uppercase mb-8 block" data-id="element-36">
            Est. 2024 • New York City
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 80
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.4,
        delay: 0.5,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="font-display text-[clamp(3rem,12vw,10rem)] font-bold leading-[0.85] tracking-tight mb-8" data-id="element-37">
          <span className="block" data-id="element-38">MOVE</span>
          <span className="block text-white/20" data-id="element-39">IN THE</span>
          <span className="block italic" data-id="element-40">Light</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.9,
        ease: 'easeOut'
      }} className="text-white/50 text-lg md:text-xl max-w-xl mx-auto mb-12 font-light" data-id="element-41">
          Where passion meets precision. Experience dance as theater, movement
          as art, and every class as a performance.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 1.2,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-42">
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="px-10 py-4 bg-[#DC2626] text-white font-medium tracking-wider uppercase text-sm hover:bg-[#b91c1c] transition-colors duration-300" data-id="element-43">
            Begin Your Journey
          </motion.button>
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="px-10 py-4 border border-white/30 text-white font-medium tracking-wider uppercase text-sm hover:border-white/60 transition-colors duration-300" data-id="element-44">
            View Schedule
          </motion.button>
        </motion.div>
      </div>

      {/* Bottom geometric line */}
      <div className="absolute bottom-0 left-0 right-0" data-id="element-45">
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.5,
        delay: 1.5,
        ease: 'easeOut'
      }} className="geometric-line w-full" data-id="element-46" />
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2" data-id="element-47">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-px h-16 bg-gradient-to-b from-white/60 to-transparent" data-id="element-48" />
      </motion.div>
    </section>;
}